import React, { PropTypes } from 'react';
import { reduxForm } from 'redux-form';
import { fieldClass } from 'common/semantic/utils';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = true;
  }

  return errors;
};

class ChapterForm extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.goBack = () => context.router.goBack();
  }

  render() {
    const { fields: { name }, handleSubmit, submitting } = this.props;

    return (
      <form className="ui form" onSubmit={handleSubmit}>
        <div className="ui top attached segment">
          <div className={fieldClass(name)}>
            <label>Nom</label>
            <input type="text" name="name" placeholder="Nom" {...name} />
          </div>
        </div>
        <div className="ui bottom attached clearing segment">
          <button
            className="ui right floated primary button"
            type="submit"
            disabled={submitting}
          >
            Valider
          </button>
          <button className="ui right floated button" onClick={this.goBack}>
            Annuler
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'chapter',
  fields: ['name'],
  validate,
})(ChapterForm);



// WEBPACK FOOTER //
// ./src/modules/memo/components/ChapterForm.js